import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgFill } from '@chegg-ui/svg-icon';
import { DirectionalSvgIcon } from '../../styles';
var Arrow = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DirectionalSvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.12 31.037 22.962 44.045c-.506.5-1.418.5-1.924 0L7.88 31.037c-.507-.5-.507-1.4 0-1.9.506-.501 1.417-.501 2.024 0l10.83 10.705V1.821c0-.8.608-1.401 1.418-1.401.506 0 1.214.6 1.214 1.4v37.922l10.831-10.706c.506-.5 1.417-.5 1.923 0 .507.6.507 1.401 0 2.001Z"
  }));
});
Arrow.displayName = 'Arrow';
Arrow.defaultProps = {
  'aria-label': 'Arrow'
};
export default Arrow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Arrow.js
// module id = 3096
// module chunks = 11